/** Figma 16999:434830 a 16999:436055 e 17005:436090 (escopo avulso); 15652:1552118, 15652:1551872 e 15652:1550648 (Tipo). */
export const AJUSTAR_TITLE = "Ajustar projeção no destino";
export const REVISAR_TITLE = "Revisar escopo macro";
export const PREVIA_PERMISSAO = "Você não tem permissão para consultar a revisão da projeção.";
export const PREVIA_ERRO = "Não foi possível calcular a revisão da projeção.";
export const TOTAL_NO_DESTINO_LABEL = "Total no destino";

export const RESUMO_TITLE = "Serviços e Materiais (resumo)";
export const RESUMO_COLUNAS = ["Tipo", "Itens", "Na origem", "Valor (R$)", "No destino"] as const;
export const PROJECAO_NO_DESTINO_TITLE = "Projeção no destino";
export const SERVICOS_TITLE = "Serviços";
export const MATERIAIS_TITLE = "Materiais";
export const DISTRIBUICAO_LABEL = (categoria: string) => `Distribuição por coletor (${categoria})`;
export const CURVA_LABEL = (categoria: string) => `Curva de mensalização (${categoria})`;
export const NA_ORIGEM = (nome: string) => `Na origem: ${nome}. Mantenha ou escolha outra.`;
export const SEM_NOME_NA_ORIGEM = "sem parâmetro";
export const SELECIONE_PLACEHOLDER = "Selecione…";

export const FATOR_TITLE = "Fator de idade da embarcação";
export const FATOR_TEXTO =
  "Escopo macro com custo padrão. O percentual usado na origem vem preenchido, inclusive quando foi ajustado à mão.";
export const FATOR_NAO_SE_APLICA =
  "Fator de idade: não se aplica. O Tipo de Obra 100 não usa custo padrão. Nos Tipos 101, 102 e 103, o percentual da origem vem preenchido e você escolhe se mantém ou atualiza.";
export const FATOR_SUBTITULO_MANTER = "Manter o percentual da origem";
export const FATOR_SUBTITULO_ATUALIZAR = "Atualizar o percentual";
export const FATOR_MANTER = (percentual: string) => `Manter ${percentual} (origem)`;
export const FATOR_ATUALIZAR = (percentual: string) => `Atualizar para ${percentual}`;
export const FATOR_ATUALIZAR_SEM_VALOR = "Atualizar para a idade da embarcação";
export const FATOR_ATUALIZAR_MANUAL = "Atualizar manualmente";
export const FATOR_CAMPO_LABEL = "Percentual do fator de idade (0 a 100)";
export const FATOR_SEM_IDADE_TEXTO =
  "A embarcação da Obra de destino não tem idade cadastrada: informe o percentual do fator.";
export const FATOR_OBRIGATORIO = "Informe o percentual do fator de idade.";
export const FATOR_FORA_DA_FAIXA = "O percentual do fator de idade deve estar entre 0 e 100.";
export const VALOR_ESCOPO = (valor: string, igualOrigem: boolean, origem: string) =>
  igualOrigem
    ? `Valor do escopo: ${valor} (mesmo da origem).`
    : `Valor do escopo: ${valor} (na origem: ${origem}).`;
export const FATOR_RECALCULADO = (anterior: string, recalculado: string, diferenca: string) =>
  `Valor anterior ${anterior} → recalculado ${recalculado} (${diferenca}). O cálculo parte do valor-base, sem aplicar o fator duas vezes.`;
export const FATOR_DIFERENCA = (sinal: "+" | "-", valor: string) => `${sinal} ${valor}`;
export const FATOR_SEM_DIFERENCA = "sem diferença";

export const MENSALIZACAO_TITLE = "Mensalização no destino (R$ mil)";
export const MENSALIZACAO_CATEGORIA = "Categoria";
export const MENSALIZACAO_TOTAL = "Total";
export const CARREGANDO_LABEL = "Calculando a projeção no destino…";

export const CANCELAR_LABEL = "Cancelar";
export const APLICAR_LABEL = "Aplicar ajustes";
export const AJUSTAR_FORM_ID = "ajustar-projecao-form";
